<template>
    <div>
        <v-btn
            @click="toggleAddDialog()"
            class="info text--white"
            slot="activator"
        >Add Course
        </v-btn>
        <v-dialog
            :value="addCourseDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Course</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex>
                                <v-select
                                    :error-messages="addCourseTypeIdErrors"
                                    :items="courseTypeList"
                                    item-text="name"
                                    item-value="id"
                                    @blur="$v.addCourseTypeId.$touch()"

                                    @input="$v.addCourseTypeId.$touch()"
                                    label="Course Type"
                                    v-model="addCourseTypeId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Title"
                                    v-model="addTitle"
                                    :error-messages="addTitleErrors"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Description"
                                    v-model="addDescription"
                                    :error-messages="addDescriptionErrors"
                                />
                            </v-flex>
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"
                                    v-model="startDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.addStartDate.$touch()"
                                            @input="startDateMenu = false && $v.addStartDate.$touch()"
                                            label="Start Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="addStartDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.addStartDate.$touch()"
                                        @input="startDateMenu = false && $v.addStartDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="addStartDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.addStartDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"
                                    v-model="endDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.addEndDate.$touch()"
                                            @input="endDateMenu = false && $v.addEndDate.$touch()"
                                            label="End Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="addEndDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.addEndDate.$touch()"
                                        @input="endDateMenu = false && $v.addEndDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="addEndDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.addEndDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="290px"
                                    offset-y
                                    transition="scale-transition"
                                    v-model="renewalDateMenu"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            @blur="$v.addRenewalDate.$touch()"
                                            @input="renewalDateMenu = false && $v.addRenewalDate.$touch()"
                                            label="Renewal Date"
                                            prepend-icon="event"
                                            readonly
                                            slot="activator"
                                            :value="addRenewalDate | formatDate"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        @blur="$v.addRenewalDate.$touch()"
                                        @input="renewalDateMenu = false && $v.addRenewalDate.$touch()"
                                        no-title
                                        scrollable
                                        v-model="addRenewalDate"
                                    >
                                    <v-btn text color="primary" @click="() => {this.addRenewalDate = null}">Clear</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-textarea
                                    label="Comments"
                                    v-model="addComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { FETCH_PERSONNEL } from "@/store/person/actions.js";
import { FETCH_PERSON_COURSE_LIST, SAVE_NEW_PERSON_COURSE_BY_PERSON_ID } from "@/store/person_course/actions.js";
import { RESET_DEFAULT_NEW_PERSON_COURSE, TOGGLE_NEW_PERSON_COURSE_DIALOG, UPDATE_ADD_PERSON_COURSE_FIELD } from "@/store/person_course/mutations.js";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from './../../../ManagePersonnel/components/editTableFunctions';

    export default {
        name: "AddCourseDialog",

        validations: {
            addTitle: {required},
            addDescription: {required},
            addCourseTypeId: {required},
            addStartDate: {required},
        },

        mixins: [
            EditTableFunctions,
        ],

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: () => ({
            startDateMenu: false,
            endDateMenu: false,
            renewalDateMenu: false,
        }),

        computed: {
            ...mapGetters(
                [
                    "courseTypeList",
                ]
            ),
            addCourseDialog: {
                get() {
                    return this.$store.state.person_course.addPersonCourseDialog;
                },
            },
            addTitle: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.title;
                },
                set(value) {
                    this.updateNewValue('title', value);
                },
            },
            addTitleErrors() {
                const errors = [];
                if (!this.$v.addTitle.$dirty) return errors;
                !this.$v.addTitle.required && errors.push('required.');
                return errors
            },
            addDescription: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.description;
                },
                set(value) {
                    this.updateNewValue('description', value);
                },
            },
            addDescriptionErrors() {
                const errors = [];
                if (!this.$v.addDescription.$dirty) return errors;
                !this.$v.addDescription.required && errors.push('required.');
                return errors
            },

            addCourseTypeId: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.courseTypeId;
                },
                set(value) {
                    this.updateNewValue('courseTypeId', value);
                },
            },

            addCourseTypeIdErrors() {
                const errors = [];
                if (!this.$v.addCourseTypeId.$dirty) return errors;
                !this.$v.addCourseTypeId.required && errors.push('required.');
                return errors
            },

            addStartDate: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.startDate;
                },
                set(value) {
                    this.updateNewValue('startDate', value);
                },
            },

            addStartDateErrors() {
                const errors = [];
                if (!this.$v.addStartDate.$dirty) return errors;
                !this.$v.addStartDate.required && errors.push('required.');
                return errors
            },

            addComments: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.comments;
                },
                set(value) {
                    this.updateNewValue('comments', value);
                },
            },

            addEndDate: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.endDate;
                },
                set(value) {
                    this.updateNewValue('endDate', value);
                },
            },

            addRenewalDate: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.renewalDate;
                },
                set(value) {
                    this.updateNewValue('renewalDate', value);
                },
            },
            addPersonId: {
                get() {
                    return this.$store.state.person_course.addPersonCourse.personId;
                },
                set(value) {
                    this.updateNewValue('personId', value);
                },
            }
        },

        mounted() {
            if (this.personId !== undefined) {
                this.resetNewItemToDefault(this.personId);
                this.updateNewValue('personId', this.personId);
                this.fetchPersonnel();
            }
        },

        methods: {
            fetchPersonnel() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            ...mapActions({
                fetchTableList: FETCH_PERSON_COURSE_LIST,
                saveNewTableItemRecord: SAVE_NEW_PERSON_COURSE_BY_PERSON_ID,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_PERSON_COURSE_DIALOG,
                updateTableItemToAdd: UPDATE_ADD_PERSON_COURSE_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_PERSON_COURSE,
            }),
        }
    }
</script>